/// <reference path="../../polaris-web-components.d.ts" />
import React, { Component } from 'react';
import { useCallback, useEffect, useState, useMemo } from "react";
import WatermarkImage from '../../assets/3129492.jpg';
import { getShopUrl, getExportConfig, getTrialStatus, ChargeUrl } from '../Services/CommonServices';
import { downloadTranslationBulkResult, translationBulkCancel, TranslationBulkPolling, DeleteTranslationLogs, getTranslationImportHistory } from '../Services/TranslationService';
import { environment } from '../Services/environment';
import { validConversionPrice } from '../Validation/regex';
import { ValidationErrorModal } from '../common/ValidationErrorModal';
import { ToastMarkup } from '../common/ToastMarkup';
import ExportStatusCard from '../common/ExportStatusCard';
import MappingModal from '../common/MappingModal';
import TrialExpiredBanner from '../common/TrialExpiredBanner';
import ImportHistory from '../common/ImportHistory';
import ImportProcessing from '../common/ImportProcessing';
import { errorModal, WarningModal } from '../common/ErrorModal';
import { useNavigate } from 'react-router-dom';
// import { useNavigationHistory } from '@shopify/app-bridge-react';
const endpoint = environment.serverUrl;

export default function Translations({ blockUpload,eventSource }) {
    const navigate = useNavigate();
    // const {push} = useNavigationHistory();
    var queryString = window.location.search;
    var storeUrl = getShopUrl();
    const [mappedHeaders, setMappedHeaders] = useState({});
    const CHUNK_SIZE = 1048576; // 1MB
    const [file, setFile] = useState();
    const [dropZoneKey, setDropZoneKey] = useState(0);  // Key to force dropzone re-render
    const [logsLoading, setLogsLoading] = useState(false);
    const [rejectedFiles, setRejectedFiles] = useState();
    const hasError = rejectedFiles != null;
    const [ exportLoading, setExportLoading] = useState(false);
    const validFileTypes = ['.csv','.CSV','text/csv','.xlsx','.XLSX'];
    const handleDropZoneDrop = useCallback(
        (_dropFiles, acceptedFiles, _rejectedFiles) => {
            setUploadErrors(false);
            setIsUploadError(false);
            setBulkErrors([]);
            setFile(acceptedFiles[0])
            setRejectedFiles(_rejectedFiles[0])
        },
        [],
    );
    
    const options = [
        { label: "ARTICLE", value: "ARTICLE" },
        { label: "BLOG", value: "BLOG" },
        { label: "COLLECTION", value: "COLLECTION" },
        { label: "DELIVERY_METHOD_DEFINITION", value: "DELIVERY_METHOD_DEFINITION" },
        { label: "EMAIL_TEMPLATE", value: "EMAIL_TEMPLATE" },
        { label: "FILTER", value: "FILTER" },
        { label: "LINK", value: "LINK" },
        { label: "MENU", value: "MENU" },
        { label: "METAFIELD", value: "METAFIELD" },
        { label: "METAOBJECT", value: "METAOBJECT" },
        { label: "ONLINE_STORE_THEME", value: "ONLINE_STORE_THEME" },
        { label: "ONLINE_STORE_THEME_APP_EMBED", value: "ONLINE_STORE_THEME_APP_EMBED" },
        { label: "ONLINE_STORE_THEME_JSON_TEMPLATE", value: "ONLINE_STORE_THEME_JSON_TEMPLATE" },
        { label: "ONLINE_STORE_THEME_LOCALE_CONTENT", value: "ONLINE_STORE_THEME_LOCALE_CONTENT" },
        { label: "ONLINE_STORE_THEME_SECTION_GROUP", value: "ONLINE_STORE_THEME_SECTION_GROUP" },
        { label: "ONLINE_STORE_THEME_SETTINGS_CATEGORY", value: "ONLINE_STORE_THEME_SETTINGS_CATEGORY" },
        { label: "ONLINE_STORE_THEME_SETTINGS_DATA_SECTIONS", value: "ONLINE_STORE_THEME_SETTINGS_DATA_SECTIONS" },
        { label: "PACKING_SLIP_TEMPLATE", value: "PACKING_SLIP_TEMPLATE" },
        { label: "PAGE", value: "PAGE" },
        { label: "PAYMENT_GATEWAY", value: "PAYMENT_GATEWAY" },
        { label: "PRODUCT", value: "PRODUCT" },
        { label: "PRODUCT_OPTION", value: "PRODUCT_OPTION" },
        { label: "PRODUCT_OPTION_VALUE", value: "PRODUCT_OPTION_VALUE" },
        { label: "SELLING_PLAN", value: "SELLING_PLAN" },
        { label: "SELLING_PLAN_GROUP", value: "SELLING_PLAN_GROUP" },
        { label: "SHOP", value: "SHOP" },
        { label: "SHOP_POLICY", value: "SHOP_POLICY" }
    ];

    const [translationResourceTypes, setTranslationResourceTypes] = useState(options);
    
    const [rootObjectCount, setRootObjectCount] = useState(0);
    const [exportConfig, setExportConfig] = useState(null);
    const [exportResult, setExportResult] = useState({});
    let isExportConfig = false;
    const [mutationType, setMutationType] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [uploadStatus, setUploadStatus] = useState(false);
    const [exportStatus, setExportStatus] = useState("");
    const [uploadErrors, setUploadErrors] = useState([]);
    const [isUploadError, setIsUploadError] = useState(false);
    const [exportBtnLoading, setExportBtnLoading] = useState(false);
    const [downloadSpinner, setDownloadSpinner] = useState(false);
    const [conversionPrice, setConversionPrice] = useState();
    const [configLoading, setConfigLoading] = useState(false);
    const [bulkStatus, setBulkStatus] = useState("");
    const [pollingResult, setPollingResult] = useState(undefined);
    const [bulkErrors, setBulkErrors] = useState([]);
    const [logs, setLogs] = useState([]);
    const [nxtButton, setNxtButton] = useState(true);
    const [prvButton, setPrvButton] = useState(true);
    const [loadingMap, setLoadingMap] = useState({});
    const [translationErrors, setTranslationErrors] = useState([]);
    const [translationErrorActive, setTranslationErrorActive] = useState(false);

    const pageSize = 10;
    let [pageNo, setPageNo] = useState(1);
    let [pageCount, setPageCount] = useState(0);
    const [bulkMetaErrorActive, setBulkMetaErrorActive] = useState(false);
    const [bulkMetaErrors, setBulkMetaErrors] = useState([]);
    const handleMetaBulkErrorChangeModal = useCallback(() => setBulkMetaErrorActive(!bulkMetaErrorActive), [bulkMetaErrorActive]);
    const handleTranslationErrorChangeModal = useCallback(() => setTranslationErrorActive(!translationErrorActive), [translationErrorActive]);
    const [uploadWarningsActive, setUploadWarningsActive] = useState(false);
    const [uploadWarnings, setUploadWarnings] = useState([]);
    const handleUploadWarningsChangeModal = useCallback(() => setUploadWarningsActive(!uploadWarningsActive), [uploadWarningsActive]);
    const handleChangeConversionPrice = useCallback((newValue) => { if (ValidatePrice(newValue)) { setConversionPrice(newValue) } }, []);
    
    const fileUpload = useMemo(() => 
        !file && <s-text>Click here to upload a file</s-text>
    , [file]);
    
    const uploadedFile = useMemo(() => 
        file && (
            <s-stack direction="inline" gap="small" alignment="center">
                <s-thumbnail
                    alt={file.name}
                    source={
                        validFileTypes.includes(file.type)
                            ? window.URL.createObjectURL(file)
                            : <s-icon type="edit" />
                    }
                />
                <s-stack gap="small-100">
                    <s-text>
                        {file.name}
                    </s-text>
                    <s-text>
                        {file.size} bytes
                    </s-text>
                </s-stack>
            </s-stack>
        )
    , [file]);

    const [vendorArray, setVendorArray] = useState([]);
    const [popoverActive, setPopoverActive] = useState(false);
    const [errModalActive, setErrModalActive] = useState(false);
    const [bulkErrorActive, setBulkErrorActive] = useState(false);
    const handleErrorChangeModal = useCallback(() => setErrModalActive(!errModalActive), [errModalActive]);
    const handleBulkErrorChangeModal = useCallback(() => setBulkErrorActive(!bulkErrorActive), [bulkErrorActive]);
    const togglePopoverActive = useCallback(() => setPopoverActive((popoverActive) => !popoverActive), [],);
    const [uploadBtnLoading, setUploadBtnLoading] = useState(false);
    const [toast, setToast] = useState(false);
    const toggleToast = useCallback(() => setToast((toast) => !toast), []);
    const [processingMsg, setProcessingMsg] = useState('calculating items');
    const [catalogExtractMsg, setCatalogExtractMsg] = useState();
    const [mappingProgress, setMappingProgress] = useState(0);
    const [translationDeleteStatus, setTranslationDeleteStatus] = useState();
    const [metaDeleteStatus, setMetaDeleteStatus] = useState();
    const [splitTranslations, setSplitTranslations] = useState();
    const [stagedUploadProgress, setStagedUploadProgress] = useState();
    const [translationBulkCancelStatus, setBulkCancelStatus] = useState("")
    const [emailMarketingUpdate,setEmailMarketingUpdate] = useState(undefined);
    const [selectedExportFilters, setSelectedExportFilters] = useState([]);
    const [active, setActive] = useState(false);
    const handleChangeModal = useCallback(() => { if (!active) { }  setActive(!active); }, [active]);
    const [selectedType, setSelectedType] = useState("PRODUCT");
    const [totalTranslationCount, setTotalTranslationCount] = useState(null);
    const [exportFilterMsg, setExportFilterMsg] = useState(null);

    // Trial Authorization States
    const [trialInfo, setTrialInfo] = useState(null);
    const [showTrialBanner, setShowTrialBanner] = useState(false);

    const [isModalActive, setIsModalActive] = useState(false);
    const [ mapModalLodaing, setMapModalLoading] = useState(false);
    const [exportModalLoading,setExportModalLoading] = useState(false);
    
  // Example headers
  const [shopifyHeaders,setShopifyHeaders] = useState([]);
  const [catalogHeaders,setCatalogHeaders] = useState([]);
  const [formSubmit, setFormSubmit] = useState(false);
  const [importLoading, setImportLoading] = useState(false);
  const [notificationResult, setNotificationResult] = useState(undefined);
  const [translationStatus, setTranslationStatus] = useState("");
  const [validationErrModalActive, setValidationErrModalActive] = useState(false);
    const handleValidationErrorChangeModal = useCallback(() => setValidationErrModalActive(!validationErrModalActive), [validationErrModalActive]);
    const [FileErrors, setFileErrors] = useState([]);
    const [compareTranslations, setCompareTranslations] = useState();
    useEffect(() => {
        getConfigExport();
        
        setFile(null);
        deleteOlderLogs();
        statusPolling();
        getLogs();
        loadTrialStatus(); // Load trial authorization
        // checkExportStatus();
    }, []);

    // ========== Trial Authorization Functions ==========
    
    const loadTrialStatus = async () => {
        try {
            const data = await getTrialStatus(storeUrl);
            setTrialInfo(data);
            
            // Show banner if trial expired and no active charge
            if (data.isTrialExpired && !data.hasActiveCharge) {
                setShowTrialBanner(true);
            }
        } catch (error) {
            console.error('Error loading trial status:', error);
        }
    };

    const checkTrialAccess = () => {
        if (!trialInfo) return true; // Loading state, allow temporarily
        
        if (!trialInfo.canAccessApp) {
            setShowTrialBanner(true);
            return false;
        }
        return true;
    };

    const handleTrialBannerDismiss = () => {
        setShowTrialBanner(false);
    };

    const handleUpgradeAction = () => {
        
        navigate('/plans' + queryString);
    };
    // ========== End Trial Authorization Functions ==========

   useEffect(() => {
    if(isModalActive===false)
    {
        setFile(null);
        setUploadStatus(false);
    }
    }, [isModalActive]);

    useEffect(() => {
        if(formSubmit)
        {
            handleSubmit();
            setFile(null);
        }
    }, [mappedHeaders,formSubmit]);

    // Fetch export config when export status changes to completed
    useEffect(() => {
        if (exportStatus === "completed" || exportStatus === "failed") {
            getConfigExport();
        }
    }, [exportStatus]);


    function generateProductErrorModal(errors) {
        console.log("Translation errors:", errors);
        // Translation errors already come in the correct format from backend:
        // [{ handle, userErrors: [{ message, field }] }]
        // No transformation needed
        setBulkErrors(errors || []);
        setBulkErrorActive(true);
        
        // Open the modal using command after state update
        setTimeout(() => {
            const modal = document.getElementById('bulk-error-modal');
            if (modal) {
                // Trigger the show command on the modal
                modal.dispatchEvent(new CustomEvent('command', { detail: { action: 'show' } }));
            }
        }, 0);
    }


    const handleSubmit = () => {
        // const isTitleMapped = Object.keys(mappedHeaders).some((key) => key === "Handle");
        // if (isTitleMapped) {
            const jsonData = JSON.stringify(mappedHeaders);
            const formData = new FormData();
            formData.append('MappingData', jsonData);
            formData.append('File', file, file.name);
            formData.append('StoreUrl', storeUrl);
            formData.append('Type', selectedType);
            const requestOptions = {
              method: 'POST',
              body: formData,
            };
    
            fetch(endpoint + '/api/Translation/process-mappings', requestOptions)
              .then((response) => {
                if (response.status === 400) {
                  return response.json().then((errorData) => {
                    if (errorData.message.includes('metafields')) {
                      throw new Error(`Translation mapping: ${errorData.message}`);
                    }
                    else {
                      throw new Error(`Bad Request: ${errorData.message}`);
                    }
                  });
                } else if (!response.ok) {
                  throw new Error('Server Error');
                }
                return response.json();
              })
              .then((data) => {
              })
              .catch((error) => {
                if (error.message.startsWith('Bad Request')) {
                //   uploadError("server");
                }
                else if (error.message.startsWith('Metafields')) {
                //   uploadError("metafield");
                }
              })
              .finally(() => {
                setActive(false);
              });
            setActive(false);
        //   }
        // else {
        //   setProductMappingError("Mapping the 'Handle' Shopify header is required.");
        //   setSaveTempLoading(false);
        // }
      };


      useEffect(() => {
 if (eventSource) {
        eventSource.onmessage = (event) => {
            const data = event.data;
            
            // Handle detailed import progress messages
            if (data.includes("translationimportprogress")) {
                const jsonObject = JSON.parse(data);
                setImportLoading(false);
                setUploadStatus(true);
                setTranslationStatus("processing");
                
                // Map step to user-friendly message
                const stepMessages = {
                    "uploading": "Uploading catalog file...",
                    "initializing": "Initializing translation import...",
                    "querying": "Querying existing translations...",
                    "parsing": "Parsing catalog file...",
                    "calculating": jsonObject.message || "Calculating items...",
                    "stagedupload": "Preparing staged uploads...",
                    "uploadcomplete": "Upload complete!"
                };
                
                setProcessingMsg(stepMessages[jsonObject.step] || jsonObject.message);
            }
            else if (data.includes("Processing file") || data.includes("Extracting translations") || data.includes("Preparing bulk operation")) {
                setImportLoading(false);
                setUploadStatus(true);
                setTranslationStatus("processing");
                setProcessingMsg("Processing file...");
            }
            else if (data.includes("Calculating items")) {
                setImportLoading(false);
                setUploadStatus(true);
                setTranslationStatus("processing");
                setProcessingMsg("validating");
            }
            else if(data.includes("translationimportquery")) {
                console.log("translationimportquery",data);
                const jsonObject = JSON.parse(data);
                const { status} = jsonObject;
                console.log("status",status);
                setImportLoading(false);
                setUploadStatus(true);
                setTranslationStatus("processing");
                setProcessingMsg("Querying translations: " + status);
            }

            else if (data.includes("translationcatalogextract")) {
                setImportLoading(false);
                const jsonObject = JSON.parse(data);
                setUploadStatus(true);
                setTranslationStatus("processing");
                setCatalogExtractMsg(jsonObject);
                setProcessingMsg("Catalog extract");
            }
            else if (data.includes("processing")) {
                setImportLoading(false);
                const jsonObject = JSON.parse(data);
                setUploadStatus(true);
                setTranslationStatus("processing");
                setMappingProgress(jsonObject);
                setProcessingMsg("progress");
            }
            else if (data.includes("translationscompare")) {
                setImportLoading(false);
                const jsonObject = JSON.parse(data);
                setUploadStatus(true);
                setTranslationStatus("processing");
                setCompareTranslations(jsonObject);
                setProcessingMsg("Compare translations");
            }
            else if (data.includes("translationuploadbulk")) {
                setImportLoading(false);
                setUploadStatus(true);
                const jsonObject = JSON.parse(data);
                console.log("translationuploadbulk received:", jsonObject);
                
                if (jsonObject) {
                    const { status, bulkId } = jsonObject;
                    
                    if (status && status.toLowerCase() === "completed") {
                        setNotificationResult(jsonObject);
                        setBulkStatus(status);
                        setUploadStatus(false);
                        getLogs();
                    } else if (status && status.toLowerCase() === "canceled") {
                        setUploadStatus(false);
                        setBulkStatus(status);
                        getLogs();
                    } else {
                        // Still running
                        setUploadStatus(true);
                        setBulkStatus(status || "running");
                        setNotificationResult(jsonObject);
                        setTranslationStatus("processing");
                        setProcessingMsg("Processing translations");
                    }
                }
            } else if (data.includes("translationimportcompleted")) {
                setImportLoading(false);
                setNotificationResult(undefined);
                getLogs();
                setUploadStatus(false);
                setFile(null);  // Reset file state to allow new uploads
                setRejectedFiles(null);  // Reset rejected files
                setDropZoneKey(prev => prev + 1);  // Force dropzone re-render
                setTranslationStatus("");  // Reset translation status
                setProcessingMsg("calculating items");  // Reset processing message
                setCatalogExtractMsg(undefined);  // Reset catalog extract message
                setCompareTranslations(undefined);  // Reset compare translations
            } else if (data.includes("translationdownloadComplete")) {
                setExportStatus("completed");
                // if (exportConfig === null && !isExportConfig) {
                    isExportConfig = true;
                    getConfigExport();
                // }
                // window.location.href = endpoint + '/api/Page/download-previous-export?storeUrl=' + storeUrl;
                setExportLoading(false);
                setDownloadSpinner(false);
            }

            else if (data.includes("Export")) {
                if (exportConfig === null && !isExportConfig) {
                    isExportConfig = true;
                    
                }
                try
                {
                const jsonObject = JSON.parse(data);
                if (jsonObject) {
                    const { type, status,completedAt } = jsonObject;
                    if (type.includes("Product")) { setMutationType("product"); }
                    else if (type.includes("Translation")) { setMutationType("translation"); setExportResult(jsonObject);}
                    if(status.toLowerCase() === "completed" || status.toLowerCase() === "failed" || status.toLowerCase() === "expired" || status.toLowerCase() === "canceled")
                    {
                        setDownloadSpinner(false);
                        setExportBtnLoading(false);
                        if(type.includes("Translation"))
                        {
                            setExportResult(jsonObject);
                            setExportStatus(status.toLowerCase());
                            setExportCompletedAt(completedAt);
                        }

                        if(type === "TranslationExport")
                                {
                                    setDownloadSpinner(false);
                                    setExportBtnLoading(false);
                                    // window.location.href = endpoint + '/api/Translation/download-previous-export?storeUrl=' + storeUrl;
                                }
                    }
                    setExportStatus(status.toLowerCase());
                }
            } catch (err) {
                console.warn("Non-JSON message received:", data);
            }
            }

            else if (data.includes("translationfailed")) {
                setExportStatus("failed");
                if (exportConfig === null && !isExportConfig) {
                    isExportConfig = true;
                    getConfigExport();
                }
                setExportLoading(false);
                setDownloadSpinner(false);
                setNotificationResult(undefined)
            }
            else if (data.includes("translationValidation")) {
                const { pageValidation } = JSON.parse(data);
                if (pageValidation === true) {
                } else {
                    setFile(null);
                    setFileErrors(JSON.parse(data));
                    setProcessingMsg("failed");
                    setTranslationStatus("failed")
                    setImportLoading(false);
                    setUploadStatus(false);
                    setValidationErrModalActive(true);;
                }
            }
        }
    }
        return () => {
            if (eventSource) {
              eventSource.onmessage = null; // Remove the event handler
            }
          };
        }, [eventSource]);
        
        

        // return () => {
        //     if (eventSource) {
        //       eventSource.onmessage = null; // Remove the event handler
        //     }
        //   };
        // }, [eventSource]);

    const activator = (
        <s-button onClick={togglePopoverActive} disclosure>
            Export
        </s-button>
    );



    const bulkResponseErrorModal = (
        <s-modal
            id="bulk-error-modal"
            size="base"
            heading="Failed translations"
            padding="none"
        >
                <s-table padding="none">
                    <s-table-header-row>
                        <s-table-header>Sl No</s-table-header>
                        <s-table-header>ID</s-table-header>
                        <s-table-header>Error</s-table-header>
                    </s-table-header-row>
                    <s-table-body>
                        {bulkErrors?.map(({ handle, userErrors }, index) => (
                            <s-table-row key={index}>
                                <s-table-cell>
                                    <s-text type="strong">{index + 1}</s-text>
                                </s-table-cell>
                                <s-table-cell>
                                    <s-text>{handle}</s-text>
                                </s-table-cell>
                                <s-table-cell>
                                    <s-text tone="critical">
                                        {userErrors?.[0]?.message || 'Unknown error'}
                                    </s-text>
                                </s-table-cell>
                            </s-table-row>
                        ))}
                    </s-table-body>
                </s-table>
            
            <s-button 
                slot="primary-action"
                commandFor="bulk-error-modal"
                command="--hide"
                onClick={handleBulkErrorChangeModal}
            >
                Close
            </s-button>
        </s-modal>
    );



    function next() {
        pageNo = pageNo + 1
        if (pageNo <= pageCount) {
            setPageNo(pageNo);
            getLogs();
            setPrvButton(true);
        }
        else { setNxtButton(false); setPrvButton(true); }
    }
    function prev() {
        pageNo = pageNo - 1
        if (pageNo >= 1) {
            setPageNo(pageNo);
            getLogs();
            setNxtButton(true)
        }
        else { setPrvButton(false); setNxtButton(true) }
    }

    function generateMetafieldErrorModal(errors) {
        setBulkMetaErrors(errors);
        setBulkMetaErrorActive(true)
    }

    function generateUploadWarningsModal(warnings) {
        console.log("Upload Warnings generateUploadWarningsModal", warnings);
        setUploadWarnings(warnings);
        setUploadWarningsActive(true);
    }

    const [exportCompletedAt, setExportCompletedAt] = useState('');
    // const [exportModalActive, setExportModalActive] = useState(false);
    // const exportModal = (
    //     <>
    //         <Modal
    //             primaryAction={{
    //                 content: 'Export',
    //                 onAction: exportAllTranslations,
    //                 disabled: exportStatus === 'running' || exportStatus === 'failed' || uploadStatus || blockUpload ? true : false,
    //             }}
    //             open={exportModalActive}
    //             title="Export"
    //             onClose={() => {setExportModalActive(false)}}>
    //                 <Modal.Section>
    //                     <Banner
    //                         status={exportStatus === "completed" ? "success" : exportStatus === "failed" ? "critical" : "info"}
    //                         onDismiss={false}>
    //                         <Text>
    //                             {exportStatus === "completed" ?
    //                                 "Export " + (mutationType !== '' && mutationType !== undefined ? " " + mutationType : "") + " completed on " + new Date(exportCompletedAt).toLocaleDateString() + " at " + new Date(exportCompletedAt).toLocaleTimeString() + ". "
    //                                 : exportStatus === "" ?  "No previous export Found. Please export again." :  "Export " + (mutationType !== '' && mutationType !== undefined ? " " + mutationType : "") + " " + exportStatus + (exportStatus !== "failed" ? ". This may take a few moments." : ".")}
    //                             {exportStatus === "completed" && !downloadSpinner? <Link url="" onClick={() => {
    //                                 setDownloadSpinner(true);
    //                                 window.location.href = endpoint + '/api/Translation/download-previous-export?storeUrl=' + storeUrl;
    //                             }}>Download</Link> : downloadSpinner ? <Spinner  size="small" /> : null}
    //                         </Text>
    //                     </Banner>
    //                 </Modal.Section>
                    
    //         </Modal>
    //     </>
    // );

    const modal = (
        <s-modal
            id="export-modal"
            heading="Export"
            padding="none"
        >
            {exportModalLoading === false ?
                <s-box padding="base">
                    <s-stack gap="medium">
                        <s-select
                            label="Type"
                            value={selectedType}
                            onChange={(e) => { setSelectedType(e.currentTarget.value);} }
                        >
                            {translationResourceTypes.map((option) => (
                                <s-option key={option.value} value={option.value}>
                                    {option.label}
                                </s-option>
                            ))}
                        </s-select>
                        
                        {exportFilterMsg !== null && (
                            <s-text tone="success">{exportFilterMsg}</s-text>
                        )}
                    </s-stack>
                </s-box>
                : 
                <s-box padding="large">
                    <s-stack alignment="center" inline-align="center">
                        <s-spinner size='small' />
                    </s-stack>
                </s-box>
            }
            
            <s-button 
                slot="secondary-actions"
                commandFor="export-modal"
                command="--hide"
            >
                Cancel
            </s-button>
            <s-button 
                slot="primary-action"
                variant="primary"
                onClick={() => { exportTranslationsByType(); }}
                commandFor="export-modal"
                command="--hide"
                disabled={!["completed", "", "canceled", "expired","failed"].includes(exportStatus) || !!uploadStatus || !!blockUpload || exportModalLoading}
            >
                Export
            </s-button>
        </s-modal>
    );

    // const importModal = (
    //     <Modal
    //         primaryAction={{
    //             content: 'Submit',
    //             onAction: () => { setMapModalLoading(true); GetMetaObjectFields(); setSelectionModalActive(false); },
    //             disabled: mapModalLodaing,
    //         }}
    //         open={isModalActive}
    //         title="Map Column Headers to Shopify Fields"
    //         onClose={() => setIsModalActive(false)}
    //     >
    //         <Modal.Section>
    //             <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginTop: '10px' }}>
    //                 <Select
    //                     label="Type"
    //                     options={translationResourceTypes}
    //                     value={selectedType}
    //                     onChange={(value) => { setSelectedType(value); } }
    //                 />
    //             </div>
    //         </Modal.Section>
    //     </Modal>
    // );

    const [selectionModalActive, setSelectionModalActive] = useState(false);
    const uploadParentSlectionModal = (
        <s-modal
            id="upload-selection-modal"
            size='small'
            heading="Translations parent selection"
            padding="none"
        >
            <s-box padding="large">
                <s-select
                    label="Type"
                    value={selectedType}
                    onChange={(e) => { setSelectedType(e.currentTarget.value);} }
                >
                    {translationResourceTypes.map((option) => (
                        <s-option key={option.value} value={option.value}>
                            {option.label}
                        </s-option>
                    ))}
                </s-select>
            </s-box>
            
            <s-button 
                slot="secondary-actions"
                commandFor="upload-selection-modal"
                command="--hide"
            >
                Cancel
            </s-button>
            <s-button 
                slot="primary-action"
                variant="primary"
                onClick={FileUploadValidation}
                commandFor="upload-selection-modal"
                command="--hide"
                loading={uploadBtnLoading}
            >
                Submit
            </s-button>
        </s-modal>
    );

    const resourceName = {
        singular: 'log',
        plural: 'logs'
    };

    const notificationIndexTable = (item) => {
        return (
            <s-section>
                <s-table>
                    <s-table-header-row>
                        <s-table-header>Id</s-table-header>
                        <s-table-header>Type</s-table-header>
                        <s-table-header>Created at</s-table-header>
                        <s-table-header>Items</s-table-header>
                        <s-table-header>Progress</s-table-header>
                        <s-table-header>Duration</s-table-header>
                        <s-table-header>Errors</s-table-header>
                        <s-table-header>Status</s-table-header>
                    </s-table-header-row>
                    <s-table-body>
                    {item.update ?
                        <s-table-row
                            id={1}
                            key={1}
                        >
                            <s-table-cell>
                                <s-stack direction="inline" gap="small">
                                    <s-text type="strong">{'#' + item.id}</s-text>
                                    {item.catalogUrl ? (
                                        <s-link url={item.catalogUrl} download={item.catalogUrl.split('/').pop()}>
                                            <s-icon type="upload" tone='base' />
                                        </s-link>
                                    ) : null}
                                </s-stack>
                            </s-table-cell>
                            <s-table-cell><s-text type="strong">Update</s-text></s-table-cell>
                            <s-table-cell>{item.updateStartTime ? item.update?.timeAgo : "_"}</s-table-cell>
                            <s-table-cell>{item.update.completed + "/" + item.update.total}</s-table-cell>
                            <s-table-cell><div style={{ width: '125px' }}>
                                <s-progress-bar progress={item.update.completed != 0 ? (item.update.completed / item.update.total) * 100 : 0} size="medium" />
                            </div></s-table-cell>
                            <s-table-cell>{item.updateEndTime ? FormatTimeDuration(item.updateStartTime, item.updateEndTime) : "_"}</s-table-cell>
                            <s-table-cell>{(item.update.errors && item.update.errors.length > 0) ?
                                <s-link tone="critical" onClick={() => generateProdutErrorModal(item.update.errors)}>
                                    <s-text tone="critical">{item.update.errors.length} errors</s-text></s-link>
                                : <s-text tone="success">_</s-text>}
                            </s-table-cell>
                            <s-table-cell><s-badge tone={item.update.status === "completed" ? "success" : "info"}>{item.update.status}</s-badge></s-table-cell>
                        </s-table-row> : null}
                    {item.create ?
                        <s-table-row>
                            <s-table-cell>
                                {/* <s-text type="strong"></s-text> */}
                                <s-stack direction="inline" gap="small">
                                    <s-text type="strong">{item.update ? "" : '#' + item.id}</s-text>
                                    {item.catalogUrl && item.update === null ? (
                                        <s-link url={item.catalogUrl} download={item.catalogUrl.split('/').pop()}>
                                            <s-icon type="upload" tone='base' />
                                        </s-link>
                                    ) : null}
                                </s-stack>
                            </s-table-cell>
                            <s-table-cell><s-text type="strong">Create</s-text></s-table-cell>
                            <s-table-cell>{item.createStartTime ? item.create?.timeAgo : "_"}</s-table-cell>
                            <s-table-cell>{item.create.completed + "/" + item.create.total}</s-table-cell>
                            <s-table-cell><div style={{ width: '125px' }}>
                                <s-progress-bar progress={item.create.completed != 0 ? (item.create.completed / item.create.total) * 100 : 0} size="medium" />
                            </div></s-table-cell>
                            <s-table-cell>{item.createEndTime ? FormatTimeDuration(item.createStartTime, item.createEndTime) : "_"}</s-table-cell>
                            <s-table-cell>{(item.create.errors && item.create.errors.length > 0) ?
                                <s-link tone="critical" onClick={() => generateProdutErrorModal(item.create.errors)}>
                                    <s-text tone="critical">{item.create.errors.length} errors</s-text></s-link>
                                : <s-text tone="success">-</s-text>}
                            </s-table-cell>
                            <s-table-cell><s-badge tone={item.create.status === "completed" ? "success" : "info"}>{item.create.status}</s-badge></s-table-cell>
                        </s-table-row> : null}
                    </s-table-body>
                </s-table>
            </s-section>
        );
    }

    const validationErrorModel = (
        <div style={{ height: '500px' }}>
            <s-modal
                id="validation-error-modal"
                heading="Issues found in the file"
            >
                <s-box padding="large">
                    <s-stack gap="medium">
                        <s-banner tone="critical">
                            {FileErrors?.errorType}
                        </s-banner>
                        <s-stack gap="extra-small">
                            {FileErrors?.errors?.map((error, index) => (
                                <s-text key={index}>{`${index + 1}. ${error}`}</s-text>
                            ))}
                        </s-stack>
                    </s-stack>
                </s-box>
                
                <s-button 
                    slot="primary-action"
                    commandFor="validation-error-modal"
                    command="--hide"
                >
                    Close
                </s-button>
            </s-modal>
        </div>
    );

    const processingStatus = () => {
        if (uploadStatus) {
            
            if (notificationResult !== undefined) {
                return (notificationIndexTable(notificationResult))
            }
            if (translationStatus === "validating" || translationStatus === "processing" || translationStatus === "failed") {
                return (
                    <>
                    <s-section>
                      <s-table selectable={false}>
                        <s-table-body>
                          <s-table-row>
                            <s-table-cell>
                              <s-stack direction="inline" gap="small" alignment="leading">
                                {translationStatus !== "failed" ? <s-spinner size="small" /> : null}
                                <s-badge tone={translationStatus === "failed" ? "critical" : "info"}>
                                  {translationStatus}
                                </s-badge>
                              </s-stack>
                            </s-table-cell>
                            
                            <s-table-cell style={{ textAlign: 'right', width: '100%' }}>
                              {translationStatus === "failed" ? (
                                <s-link commandFor="validation-error-modal">
                                  <s-text tone="critical">errors</s-text>
                                </s-link>
                              ) : (
                                <s-stack direction="inline" alignment="trailing" gap="small">
                                  {processingMsg === "Catalog extract" ? (
                                    <s-stack direction="inline" gap="small" alignment="trailing">
                                      <s-text>{catalogExtractMsg?.type === "pagecatalogextract" ? "Catalog extract" : catalogExtractMsg?.type}</s-text>
                                      <s-text type="strong">{catalogExtractMsg?.status}</s-text>
                                    </s-stack>
                                  ) : null}
                        
                                  {processingMsg === "progress" ? (
                                    <s-stack direction="inline" alignment="trailing" blockAlign="center" gap="small">
                                      <s-text>Processing: {mappingProgress?.status || 0}%</s-text>
                                      <s-box inlineSize="125px">
                                        <s-progress-bar progress={mappingProgress?.status || 0} size="medium" />
                                      </s-box>
                                    </s-stack>
                                  ) : null}
                        
                                  {processingMsg === "Compare translations" ? (
                                    <s-stack direction="inline" gap="small" alignment="trailing">
                                      <s-text>Update: <s-text type="strong">{compareTranslations?.update}</s-text></s-text>
                                    </s-stack>
                                  ) : null}
                        
                                  {processingMsg.includes("Querying translations") ? (
                                    <s-stack direction="inline" gap="small" alignment="trailing">
                                      <s-text>{processingMsg}</s-text>
                                    </s-stack>
                                  ) : null}
                                </s-stack>
                              )}
                            </s-table-cell>
                          </s-table-row>
                        </s-table-body>
                      </s-table>
                    </s-section>
                    </>
                );
            }
            
        }
        
    }

    return (
        <s-page heading='Translations'>
            <s-link slot="breadcrumb-actions" href={'/dashboard?' + queryString}>Dashboard</s-link>
            <s-button 
                slot="primary-action"
                commandFor="export-modal"
                disabled={exportStatus !== "running" && !uploadStatus && !blockUpload ? false : true}
            >
                {exportStatus !== "completed" && exportStatus !== "" ? (
                    <s-tooltip>
                        <span slot="trigger">
                            {exportBtnLoading ? <s-spinner size="small"></s-spinner> : <s-icon source="circle-down" />}
                            <s-text>Export</s-text>
                        </span>
                        <span slot="content">
                            {`${mutationType ? ` ${mutationType}` : ""} ${exportStatus}${exportStatus !== "failed" && exportStatus !== "canceled" ? ". This may take a few moments." : "."}`}
                        </span>
                    </s-tooltip>
                ) : (
                    <>
                        <s-icon source="circle-down" />
                        Export
                    </>
                )}
            </s-button>
                
            {/* Trial Expired Banner */}
            <TrialExpiredBanner
                show={showTrialBanner}
                remainingDays={trialInfo?.remainingTrialDays || 0}
                onDismiss={handleTrialBannerDismiss}
                onUpgrade={handleUpgradeAction}
            />

            {/* Main Card - Two columns layout with grid */}
            <s-stack gap="base">
            <s-section padding="base">
                <s-box padding="none">
                    <s-grid gridTemplateColumns="repeat(12, 1fr)" gap="large">
                        <s-grid-item gridColumn="span 6">
                            <s-stack gap="small">
                                {/* DropZone Section */}
                                <s-stack gap="small-100">
                                    <s-heading>Upload File</s-heading>
                                    <s-link onClick={() => openSampleFile()}>
                                        Download a sample file
                                    </s-link>
                                    
                                    <s-drop-zone
                                        key={dropZoneKey}
                                        multiple={false}
                                        accept=".csv,.xlsx"
                                        onInput={(event) => {
                                            const files = event.currentTarget.files;
                                            if (files && files.length > 0) {
                                                handleDropZoneDrop([], Array.from(files), []);
                                            }
                                        }}
                                    >
                                        {uploadedFile}
                                        {fileUpload}
                                    </s-drop-zone>
                                    
                                    <s-text color="subdued">
                                        Accepts .csv/.xlsx format. Maximum size: 20 MB
                                    </s-text>
                                </s-stack>

                                {/* Action Buttons Section */}
                                <s-stack gap="small-100">
                                    <s-stack direction="inline" gap="small">
                                        <s-button
                                            variant="primary"
                                            disabled={!file || uploadStatus || blockUpload || exportStatus === "running"}
                                            loading={uploadBtnLoading}
                                            commandFor="upload-selection-modal"
                                            onClick={() => { setUploadStatus(true); }}
                                        >
                                            Upload
                                        </s-button>
                                        {/* <s-button 
                                            variant="secondary" 
                                            onClick={() => openSampleFile()}
                                        >
                                            Download sample
                                        </s-button> */}
                                    </s-stack>
                                    
                                    {hasError && (
                                        <s-text as="p" tone="critical">
                                            {`"${rejectedFiles?.name}" is not supported. File type must be .csv or .xlsx`}
                                        </s-text>
                                    )}
                                </s-stack>
                            </s-stack>
                        </s-grid-item>
                        
                        <s-grid-item gridColumn="span 6">
                            {/* Note Section with Image Watermark */}
                            <div style={{ position: 'relative'}}>
                                {/* Watermark Image Background */}
                                <div 
                                    style={{
                                        position: 'absolute',
                                        bottom: '-90px',
                                        right: '10px',
                                        width: '300px',
                                        height: '300px',
                                        backgroundImage: `url(${WatermarkImage})`,
                                        backgroundSize: 'contain',
                                        backgroundRepeat: 'no-repeat',
                                        backgroundPosition: 'bottom right',
                                        opacity: '0.15',
                                        pointerEvents: 'none',
                                        zIndex: 0
                                    }}
                                />
                                
                                {/* Note Content - On top of watermark */}
                                <div style={{ position: 'relative', zIndex: 1 }}>
                                    <s-stack gap="small-100">
                                        <s-heading>Note</s-heading>
                                        <s-unordered-list>
                                            <s-list-item>
                                                The CSV/XLSX file should contain columns: <s-text type="strong">resourceId, locale, key, value, translatableContentDigest</s-text>
                                            </s-list-item>
                                            <s-list-item>
                                                Locale format should be like <s-text type="strong">en, fr, de</s-text> for English, French, German respectively
                                            </s-list-item>
                                            <s-list-item>
                                                The resourceId should be the Shopify global ID for the resource being translated
                                            </s-list-item>
                                            <s-list-item>
                                                Ensure translatableContentDigest matches the current content to avoid conflicts
                                            </s-list-item>
                                        </s-unordered-list>
                                    </s-stack>
                                </div>
                            </div>
                        </s-grid-item>
                    </s-grid>
                </s-box>
            </s-section>
            </s-stack>
            
            <ImportProcessing 
                bulkStatus={translationStatus}
                uploadStatus={uploadStatus}
                pollingResult={notificationResult}
                processingMsg={processingMsg}
                catalogExtractMsg={catalogExtractMsg}
                generateProductErrorModal={generateProductErrorModal}
            />
            
            {(exportResult !== undefined && exportConfig !== null) || exportStatus === "running" || exportStatus === "completed" ? 
                <>
                    <ExportStatusCard 
                        exportResult={exportResult} 
                        productProgress={rootObjectCount === undefined ? 0 : totalTranslationCount !== null ? (totalTranslationCount !== 0 ? ((rootObjectCount/totalTranslationCount)*100) : 0) : 0} 
                        exportConfig={exportConfig} 
                        currentRoute="translation" 
                    />
                </> : null}
            
            {/* <br /> */}
            <s-box paddingBlockStart="base">
            <s-section padding="none">
                <ImportHistory
                    logs={logs}
                    generateProductErrorModal={generateProductErrorModal}
                    generateMetafieldErrorModal={generateMetafieldErrorModal}
                    generateUploadWarningsModal={generateUploadWarningsModal}
                    downloadResult={downloadResult}
                    loadingMap={loadingMap}
                    logsLoading={logsLoading}
                    isCustomerImport={false}
                />
            </s-section>
            </s-box>
            {modal}
            {uploadParentSlectionModal}
            <MappingModal
                active={isModalActive}
                setActive={setIsModalActive}
                shopifyHeaders={shopifyHeaders}
                catalogHeaders={catalogHeaders}
                setTypeSelected = {setSelectedType}
                mapModalLodaing={mapModalLodaing}
                setMappedHeaders={setMappedHeaders}
                setFormSubmit={setFormSubmit}
                currentRoute={"translation"}
                blockUpload = {blockUpload}
            />
            {isUploadError ? <ValidationErrorModal
                errModalActive={errModalActive}
                handleErrorChangeModal={handleErrorChangeModal}
                uploadErrors={uploadErrors}
            /> : null}
            <ToastMarkup toast={toast} toggleToast={toggleToast} content={"Saved"} />

            {/* {resultDownloadErrorToast} */}
            {validationErrorModel}
            {WarningModal({ uploadWarnings })}
            
            {/* {errorModal({ bulkErrors })} */}
            
            {bulkResponseErrorModal}
        </s-page>
        
        // </Frame>
    );

    async function downloadResult(op, bulkId) {
        setLoadingMap((prevLoadingMap) => ({ ...prevLoadingMap, [bulkId + "_" + op]: true }));
        try {
            await downloadTranslationBulkResult(storeUrl, bulkId, op);
        } catch (error) {
            setLoadingMap((prevLoadingMap) => ({ ...prevLoadingMap, [bulkId + "_" + op]: false }));
        } finally {
            setLoadingMap((prevLoadingMap) => ({ ...prevLoadingMap, [bulkId + "_" + op]: false }));
        }
    }

    function openSampleFile() {
        window.open(environment.sampleTranslationFile, '_blank');
      }

    async function cancelBulk(bulkId) {
        translationBulkCancel(storeUrl, bulkId).then(function (result) {
            setBulkCancelStatus("canceling");
            getLogs();
        });
    }

    async function uploadChunk(chunk, chunkIndex, totalChunks) {
        const formData = new FormData();
        formData.append('file', chunk);
        formData.append('chunkIndex', chunkIndex);
        formData.append('totalChunks', totalChunks);

        const response = await fetch(endpoint + '/api/Translation/file-validation-chunk', {
            method: 'POST',
            body: formData,
        });

        if (!response.ok) {
            throw new Error('Chunk upload failed');
        }
    }

    async function FileUploadValidation() {
        // Check trial authorization
        if (!checkTrialAccess()) {
            return;
        }

        setFormSubmit(false);
        if (file !== null) {
            setBulkCancelStatus("");
            setIsUploadError(false);
            setUploadErrors(false);
            setBulkErrors([]);
            setUploadBtnLoading(true);
            
            const totalChunks = Math.ceil(file.size / CHUNK_SIZE);
            let allChunksUploaded = true;

            try {
                for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
                    const start = chunkIndex * CHUNK_SIZE;
                    const end = Math.min(start + CHUNK_SIZE, file.size);
                    const chunk = file.slice(start, end);

                    try {
                        await uploadChunk(chunk, chunkIndex, totalChunks);
                    } catch (error) {
                        allChunksUploaded = false;
                        setUploadBtnLoading(false);
                        setIsUploadError(true);
                        setUploadErrors({
                            errorType: "exception",
                            errors: ["File upload failed. Please try again."]
                        });
                        setErrModalActive(true);
                        break;
                    }
                }

                if (allChunksUploaded) {
                    const formData = new FormData();
                    formData.append('fileName', file.name);
                    formData.append('totalChunks', totalChunks);
                    formData.append('storeUrl', storeUrl);
                    formData.append('type', selectedType);

                    fetch(endpoint + '/api/Translation/read-catalog-headers', {
                        method: 'POST',
                        body: formData,
                    })
                        .then(response => {
                            if (!response.ok) {
                                throw new Error('Network response was not ok');
                            }
                            return response.json();
                        })
                        .then(data => {
                            // const defaultCSVHeaders = ["null"];
                            const fileHeaders = [data?.fileHeaders];
                            setCatalogHeaders(...fileHeaders);
                            const headersShopify = [data?.shopifyHeaders];
                            setShopifyHeaders(...headersShopify);
                            setIsModalActive(true);
                            setSelectionModalActive(false);
                            setUploadBtnLoading(false);
                        })
                        .catch(error => {
                            setUploadBtnLoading(false);
                            setIsUploadError(true);
                            setUploadErrors({
                                errorType: "exception",
                                errors: ["Failed to process file headers. Please check your file format."]
                            });
                            setErrModalActive(true);
                        });
                }
            } catch (error) {
                setUploadBtnLoading(false);
                setIsUploadError(true);
                setUploadErrors({
                    errorType: "exception",
                    errors: ["An error occurred while uploading the file. Please try again."]
                });
                setErrModalActive(true);
            }
        }
    }


    function deleteOlderLogs() {
        DeleteTranslationLogs(storeUrl).then(function (result) {
        });
    }


    function statusPolling() {
        TranslationBulkPolling(storeUrl).then(function (result) {
            if (result !== null) {
                var status = result.status;
                if (status.toLowerCase() === "completed") {
                    setPollingResult(result);
                    setBulkStatus(status);
                    setUploadStatus(false);
                    getLogs();
                }
                else if (status.toLowerCase() === "canceled") {
                    setUploadStatus(false);
                    setBulkStatus(status);
                    getLogs();
                }
                else {
                    setUploadStatus(true);
                    setBulkStatus(status);
                    setPollingResult(result);
                }
            }
            else {
            }
        })
    }
    // function checkExportStatus() {
    //     translationExportStatus(storeUrl).then(function (result) {
    //         setDownloadSpinner(true);
    //         if (result !== null) {
    //             var status = result?.status?.toLowerCase();
    //             var type = result.type
    //             if (status === "completed" && type === "translation") {
    //                 setMutationType(type);
    //                 setExportStatus(status)
    //                 setExportCompletedAt(result.completedAt)
    //                 setExportResult(result);
    //                 setDownloadSpinner(false);
    //             }
    //             else if (type === "translation" && status === "running" ) {
    //                 setMutationType(type);
    //                 setExportStatus(status)
    //                 setExportResult(result);
    //                 setDownloadSpinner(true);
    //             }
    //             else if (type === "translation" && status === "processing" ) {
    //                 setMutationType(type);
    //                 setExportStatus(status)
    //                 setExportResult(result);
    //                 setDownloadSpinner(true);
    //             }
    //             else if (status === "failed" && type === "translation") {
    //                 setDownloadSpinner(false);
    //                 setMutationType(type);
    //                 setExportResult(result);
    //                 setExportStatus("failed")
                    
    //             }

    //             else if (status === "failed" && type === "product") {
    //                 setExportStatus("completed")
    //                 setDownloadSpinner(false);
    //             }

    //             else if (type !== "translation" && status === "running" )
    //             {
    //                 setMutationType(type);
    //                 setExportStatus(status)
    //                 setExportResult(result);
    //             }

    //             else {
    //                 // setMutationType(type);
    //                 // setExportStatus("")
    //                 // checkPrevExport();
    //                 setExportResult(result);
    //                 setDownloadSpinner(false);
    //             }
    //         }
    //         else
    //         {
    //             setDownloadSpinner(false);
    //         }
    //     })
    // }
    function ValidatePrice(price) {
        if (validConversionPrice.test(price)) {
            return true;
        }
        else {
            return false;
        }

    }

    function getLogs() {
        setLogsLoading(true);
        getTranslationImportHistory(storeUrl, pageNo, pageSize).then(function (result) {
            if (result !== null) {
                // Transform translation data to match ImportHistory expected format
                // Map 'register' → 'update' and 'remove' → 'create'
                const transformedResults = result.results.map(item => ({
                    ...item,
                    update: item.register,  // Map register to update for ImportHistory
                    create: item.remove,    // Map remove to create for ImportHistory
                    importType: "Translation"  // Add import type for display
                }));
                setLogs(transformedResults);
                setPageCount((result.totalCount / pageSize) + 1);
                setLogsLoading(false);
            }
            else {
                setLogsLoading(false);
            }
        });
    }



    function getConfigExport() {
        getExportConfig(storeUrl,"translation").then(function (result) {
            if (result !== null) {
                setExportConfig(result);
            }
        });
    }

    // function QueryTranslationResourceTypes() {
    //     setExportModalLoading(true);
    //     TranslationResourceTypes(storeUrl).then(function (result) {
    //         if (result !== null) {
    //             setSelectedType(result[0]?.type);
    //             setTotalTranslationCount(result[0]?.translationsCount);
    //             setTranslationResourceTypes(result);
    //             setExportModalLoading(false);
    //         }
    //         else
    //         {
    //             setExportModalLoading(false);
    //         }
    //     });
    // }



    function exportTranslationsByType() {
        // Check trial authorization
        if (!checkTrialAccess()) {
            handleChangeModal(); // Close the export modal
            return;
        }

        setExportStatus('running');
        // setDownloadSpinner(true);
        setExportBtnLoading(true);
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        };
        const url = new URL(endpoint + '/api/Translation/translations-export');
        url.searchParams.append('storeUrl', storeUrl);
        url.searchParams.append('type', selectedType);
        fetch(url, requestOptions)
            .then(response => {
                if (response.status === 200 && response !== null) {
                    setExportBtnLoading(false);
                }
                else if (response.status === 400) {
                    setExportBtnLoading(false);
                    return response.statusText
                }
            })
            .catch(error => {
                setExportBtnLoading(false);
                return []
            })
    }

    function FormatTimeDuration(startTime, endTime) {
        var createdAt = new Date(startTime);
        var completedAt = new Date(endTime);
        var diffMs = (completedAt - createdAt); // milliseconds between now & Christmas
        var diffSec = ((diffMs % 60000) / 1000).toFixed(0); // seconds
        var diffDays = Math.floor(diffMs / 86400000); // days
        var diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
        var diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes
        var days = diffDays > 0 ? (diffDays + diffDays === 1 ? "d " : "d ") : "";
        var hours = diffHrs > 0 ? diffHrs + "h " : ""
        var mins = diffMins > 0 ? diffMins + "m " : ""
        var secs = diffSec > 0 ? diffSec + "s" : "1s"
        var duration = days + hours + mins + secs;
        return duration;
    }

    
}

